var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8242 11.9995C12.8242 10.066 14.3527 8.5 16.2367 8.5C18.1222 8.5 19.6492 10.0645 19.6492 11.9995C19.6492 13.933 18.1222 15.499 16.2367 15.499C14.3542 15.499 12.8242 13.9345 12.8242 11.9995Z",
    fill: "#1ABCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19.001C6 17.0675 7.5285 15.5 9.4125 15.5H12.825V19.001C12.825 20.933 11.2965 22.5005 9.4125 22.5005C7.5285 22.5005 6 20.933 6 19.001Z",
    fill: "#0ACF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8242 1.5V8.5005H16.2367C18.1222 8.5005 19.6492 6.933 19.6492 4.9995C19.6492 3.0675 18.1222 1.5 16.2367 1.5H12.8242Z",
    fill: "#FF7262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.9995C6 6.933 7.5285 8.5005 9.4125 8.5005H12.825V1.5H9.4125C7.5285 1.5 6 3.0675 6 4.9995Z",
    fill: "#F24E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.9995C6 13.933 7.5285 15.499 9.4125 15.499H12.825V8.5H9.4125C7.5285 8.5 6 10.0645 6 11.9995Z",
    fill: "#A259FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.a3ad81e3acc507843ab2435bcf8533c3.svg";
export { ForwardRef as ReactComponent };